import type { ColumnFiltersState } from '@tanstack/react-table';

/**
 * A column filter entry often stays in the state with an empty value once cleared
 * (a reset date picker, a value list with nothing checked), so the entry existing
 * is not enough to call the table filtered.
 */
export function hasActiveColumnFilter(columnFilters?: ColumnFiltersState) {
  return !!columnFilters?.some(
    ({ value }) =>
      value !== undefined &&
      value !== null &&
      value !== '' &&
      !(Array.isArray(value) && value.length === 0)
  );
}
